import { useEffect, useRef, useState } from 'react';
import { KOPIERT_MS, kopierbar, kopiertText, zumKopieren } from './kopieren.ts';

/**
 * Ein Wert, den man mit einem Klick in der Zwischenablage hat.
 *
 * ORIGINALTEXT MARVIN (10.09.2026)
 *   „dann brauche ich überall eine onclick-zwischenablage für sm, kls-id mit
 *    kurzer info, dass es in die zwischenablage kopiert ist."
 *
 * ES IST EIN KNOPF UND KEIN TEXT MIT `onClick`. Ein anklickbarer Text sieht
 * nicht anklickbar aus, ist mit der Tastatur nicht erreichbar und sagt einem
 * Vorleseprogramm nichts. Der Knopf trägt hier nur keinen Rahmen - er sieht
 * aus wie der Wert, den er zeigt.
 *
 * DIE RÜCKMELDUNG STEHT AN DER STELLE, AN DER GEKLICKT WURDE, und nicht als
 * Glocke am Bildschirmrand: wer 3 Nummern untereinander hat und die zweite
 * kopiert, will wissen, dass es DIE zweite war.
 *
 * DER ZEITGEBER WIRD BEIM AUFRÄUMEN ZURÜCKGENOMMEN. Ohne das schreibt er nach
 * dem Schliessen eines Fensters in einen Baustein, den es nicht mehr gibt -
 * derselbe Fehler wie beim Rennschutz des Chips „Vorbereiten".
 */
export function Kopierbar(
  { wert, was, klein }: { wert: unknown; was: string; klein?: boolean }
) {
  const [kopiert, setKopiert] = useState(false);
  const uhr = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => { if (uhr.current) clearTimeout(uhr.current); }, []);

  const text = zumKopieren(wert);
  /* EIN KOPIERKNOPF AN EINEM LEEREN FELD IST EIN VERSPRECHEN, DAS NICHT GILT. */
  if (!kopierbar(wert)) return <span className="leise">–</span>;

  function kopiere() {
    /* KEIN `catch`-ZWEIG, DER SO TUT ALS OB. Schlägt es fehl (kein sicherer
       Kontext, verweigerte Erlaubnis), bleibt die Rückmeldung aus - und der
       Mensch merkt, dass er von Hand markieren muss. Eine Bestätigung ohne
       Wirkung ist schlimmer als keine. */
    navigator.clipboard?.writeText(text)
      .then(() => {
        setKopiert(true);
        if (uhr.current) clearTimeout(uhr.current);
        uhr.current = setTimeout(() => setKopiert(false), KOPIERT_MS);
      })
      .catch(() => setKopiert(false));
  }

  return (
    <button type="button" className="kopierbar" onClick={kopiere}
            title={`${was} in die Zwischenablage`}>
      <span className="einfarbig">{text}</span>
      {kopiert
        ? <span className="kopiermarke">{kopiertText(was)}</span>
        : !klein && <span className="kopierwink" aria-hidden="true">kopieren</span>}
    </button>
  );
}
